import React from "react";
import { useContext } from "react";
import { AuthContext } from "../UserContext/AuthProvider";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
let courseId;
export const handleAdd = (id) => {
	courseId = id;
	localStorage.setItem("course", id);
};
const Checkout = () => {
	const { allData,user } = useContext(AuthContext);
	const findCourse = allData.find((s) =>
		s.id === localStorage.getItem("course")
			? localStorage.getItem("course")
			: "",
	);
	console.log(findCourse);
	return (
		<section className="container py-5">
			<div className="row">
				<div className="col-md-8 d-flex  border border-3 ps-0 rounded">
					<img src={`/${findCourse?.img}`} alt="" />
					<div className="ms-3 d-flex flex-column align-content-center justify-content-center">
						<h5>{findCourse?.name}</h5>
						<h6 className="fw-bolder">Price: ${findCourse?.price}</h6>
					</div>
				</div>
				<div className="col-md-4">
					<div className="bg-dark px-3 py-4 text-white rounded">
						<h2>Price: ${findCourse?.price}</h2>
						<Form>
							<Form.Group className="mb-3" controlId="formBasicName11">
								<Form.Label>Full Name</Form.Label>
								<Form.Control defaultValue={user?.displayName} type="text" placeholder="Enter Full Name" />
								
							</Form.Group>
							<Form.Group className="mb-3" controlId="formBasicEmail11">
								<Form.Label>Email address</Form.Label>
								<Form.Control defaultValue={user?.email} type="email" placeholder="Enter email" />
								
							</Form.Group>
							<Form.Group className="mb-3" controlId="formBasicEmail11">
								<Form.Label>Address</Form.Label>
								<Form.Control type="text" placeholder="Address" />
								
							</Form.Group>

							
							<Button className="w-100 fw-bolder bg-white text-black" type="submit">
								Proceed to Payment
							</Button>
						</Form>
					</div>
				</div>
			</div>
		</section>
	);
};

export default Checkout;
